import theme from "layout/themes";

const highchartsTheme = {
  yAxis: {
    min: 0,
    allowDecimals: false,
  },
  title: {
    text: null,
    style: {
      color: theme.palette.text.primary,
    },
  },
  legend: {
    shadow: false,
    align: "right",
    verticalAlign: "top",
    backgroundColor: theme.palette.common.white,
  },
  chart: {
    height: theme.altus.dashboard.tile.height * 2,
  },
  tooltip: {
    headerFormat: "<b>{point.x}</b><br/>",
  },
  plotOptions: {
    line: {
      marker: {
        enabled: false,
      },
    },
    column: {
      stacking: "normal",
      dataLabels: {
        enabled: true,
      },
    },
  },
};

export default highchartsTheme;
